<template>
  <onboarding-use-case />
</template>

<script>
import OnboardingUseCase from '../../../components/Onboarding/UseCase/index'
export default {
    components: {
        OnboardingUseCase
    }
}
</script>

<style>

</style>